// List Courses
export const GET_COURSES_R = '@courses/GET_COURSES_R'
export const GET_COURSES_S = '@courses/GET_COURSES_S'
export const GET_COURSES_F = '@courses/GET_COURSES_F'
export const GET_COURSES_AUTH_R = '@courses/GET_COURSES_AUTH_R'
export const GET_COURSES_AUTH_S = '@courses/GET_COURSES_AUTH_S'
export const GET_COURSES_AUTH_F = '@courses/GET_COURSES_AUTH_F'

